import { createSelector } from 'reselect'
import { RootState } from '../types'
import { LoadingStateEnum } from '../../types'

const baseSlice = (state: RootState) => state.fireblocks.base
const quoteSlice = (state: RootState) => state.fireblocks.quote

export const getFireblocksBaseLoading = createSelector(
  baseSlice,
  (s) => s.loading === LoadingStateEnum.LOADING && s.data.length === 0,
)
export const getFireblocksQuoteLoading = createSelector(
  quoteSlice,
  (s) => s.loading === LoadingStateEnum.LOADING && s.data.length === 0,
)

export const getFireblocksBaseAsset = createSelector(baseSlice, (s) => s.data)
export const getFireblocksQuoteAsset = createSelector(quoteSlice, (s) => s.data)

export const getFireblocksBaseOptions = createSelector(getFireblocksBaseAsset, (assets) =>
  assets && assets.length
    ? // eslint-disable-next-line
      assets.map((a: any) => ({
        // value: a.id,
        value: a.legacyId,
        label: a.name,
        displayName: a.displayName,
        legacyId: a.legacyId,
        iconUrl: a.iconUrl,
      }))
    : [],
)
export const getFireblocksQuoteOptions = createSelector(getFireblocksQuoteAsset, (assets) =>
  assets && assets.length
    ? // eslint-disable-next-line
      assets.map((a: any) => ({
        value: a.id,
        label: a.name,
        displayName: a.displayName,
        legacyId: a.legacyId,
        iconUrl: a.iconUrl,
      }))
    : [],
)
